<ng-container *transloco="let t">

  <div>
    <mat-label>{{label}}</mat-label>
  </div>


  <ng-container *ngFor="let c of configs">

    <data-collector-edit panelLabel="{{c.prop + (c.defaultValue ? ': ' + c.defaultValue : '')}}" [mode]="mode"
      [currentProcedureId]="currentProcedureId" [currentProcedureStepId]="currentProcedureStepId"
      [configs]="c.collectors" (configAdded)="addCollector(c.prop, $event)"
      (configRemoved)="removeCollector(c.prop, $event)">
      <div topRightButtons>
        <button *ngIf="mode === 'edit'" class="mat-elevation-z2" mat-mini-fab color="warn"
          title="{{t('buttons.delete')}}" type="button" (click)="removeProp(c.prop)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </data-collector-edit>

  </ng-container>


  <ng-container *ngIf="mode === 'edit'">

    <div class="row no-gutters">
      <div class="row flex-fill">
        <div class="col-6">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label>{{ addPropLabel || t('context-dynamic-props-edit.addProp')}}</mat-label>
            <input matInput type="text" #prop />
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label>{{ t('context-dynamic-props-edit.defaultValue')}}</mat-label>
            <input matInput type="text" #default />
          </mat-form-field>
        </div>
      </div>

      <button class="pointer ml-2 mt-1" [disabled]="!prop.value" mat-mini-fab color="accent"
        (click)="addProp(prop.value, default.value); prop.value = ''; default.value = ''" type="button">
        <mat-icon>add</mat-icon>
      </button>

    </div>

  </ng-container>

</ng-container>
